import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import banner1 from "../assets_user/img/fullbanner1.webp";
import banner2 from "../assets_user/img/fullbanner2.webp";
import banner3 from "../assets_user/img/fullbanner3.webp";
import banner4 from "../assets_user/img/fullbanner4.webp";

import grid1 from "../assets_user/img/grid1.webp";
import grid2 from "../assets_user/img/grid2.webp";
import grid3 from "../assets_user/img/grid3.webp";
import grid4 from "../assets_user/img/grid4.webp";
import gridslide1 from "../assets_user/img/gridslide1.webp";
import gridslide2 from "../assets_user/img/gridslide2.webp";
import gridslide3 from "../assets_user/img/gridslide3.webp";
import gridslide4 from "../assets_user/img/gridslide4.webp";
import gridslide5 from "../assets_user/img/gridslide5.webp";
import CreateSlug from "../components/extra/CreateSlug";
import { useBlogContext } from "../../fetchdata/BlogContext";

const HomeCartLocation = () => {

  const slug = 'delhi';

  const navigate = useNavigate();

  const {
    Headers,
    isHeader,
    cartItems,
    AllProducts,
    AllCategoriess,
    isLayoutLoading,
    layout,
  } = useBlogContext();

  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };

  const [ratings, setRatings] = useState([]);

  const [isProducts, setIsProducts] = useState(true);

  const [Products, setProducts] = useState([]);
  const [AllCategory, setAllCategory] = useState([]);

  const [defaultState, setdefaultState] = useState('delhi');


  const [loading, setloading] = useState(true);

  const [Data, setData] = useState([]);
 

  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/all-rating`);
      setRatings(data.ratings);
            console.log("getRating", data);
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

 
   const getBlog = async () => {
   
         
          setloading(true);
          try {
          const { data } = await axiosInstance.get(`/get-catgeory-product`);
         setData(data.categoriesWithProducts || []);
            // Delay the execution of buildScript by 1 secon
            console.log('datadata',data);
            const allProducts = data.categoriesWithProducts.flatMap(cat => cat.products || []);
            setProducts(allProducts ?? [])
          }
          catch (error) {
            console.log(error);
            // toast.error("Error fetching Single Blog!");
          } finally {
            setloading(false);
          }
      
      
   };
  


  useEffect(() => {
        const location = localStorage.getItem('location');
     let stateSlug  = 'delhi';
    if( location !== "[object Object]" && location){
        stateSlug = CreateSlug(location);
     } 
     setdefaultState(stateSlug);
    getBlog();
    getRating();
  }, []);

  const getProducts = async () => {
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      console.log("products", data);
      setProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <>
      <Header />

      {/* <Helmet>
        {Headers && Headers.meta_favicon && (
          <link rel="apple-touch-icon" href={Headers.meta_favicon} />
        )}
        {Headers && Headers.meta_title && (
          <>
            <title>{Headers.meta_title}</title>
            {Headers.meta_description && (
              <meta name="description" content={Headers.meta_description} />
            )}
          </>
        )}
      </Helmet> */}

      <main className="page ">
     
  <div className="container py-4">
      <div className="row">
        {/* Categories */}
        {Data.map((category) => (
          <div key={category._id} className="col-md-2 col-6 mb-4">
         <Link to={`/${category.slug}`} className="border d-block rounded p-3">
              <img
                src={category.image}
                alt={category.title}
                loading="lazy"
                style={{ aspectRatio: "1/1", objectFit: "cover" }}
                className="w-100 rounded mb-2"
              />
              <p className="m-0 text-center">{category.title}</p>
            </Link>
          </div>
        ))}
      </div>

      <div className="d-block">
        {Data.map((category) => (
          <div key={`${category._id}-products`} className="mb-5">
            <div className="d-flex align-items-center justify-content-between mt-5 mb-2">
              <h5 className="section-title mb-0">{category.title}</h5>
              <a className="see-all" href={`/${category.slug}`}>
                see all
              </a>
            </div>
            <div className="row g-3">
              {category.products && category.products.length > 0 ? (
                category.products.map((product) => (
                  <div key={product._id} className="col-6 col-md-3">
                   <Link to={`/product/${product.slug}`}   className="p-card shadow">
                      <div className="p-img-wrap p-2">
                        <img
                          className="w-100 rounded object-fit-cover"
                          src={product.pImage}
                          alt={product.title}
                          style={{ aspectRatio: "1 / 0.7" }}
                        />
                      </div>
                      <div className="px-2">
                        {/* You can add tags or badges here */}
                      </div>
                      <div className="p-body">
                        <div className="p-title">{product.title}</div>
                        <div
                          className="p-description"
                          dangerouslySetInnerHTML={{ __html: product.description }}
                        />
                        <div className="p-foot mt-0 d-flex justify-content-between align-items-center">
                          <div>
                            <span className="price">
                              ₹{product.salePrice || product.regularPrice}
                            </span>
                          </div>
                       
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
              ) : (
                <p>No products available</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>

 
  
      </main>

      <Footer />
    </>
  );
};

export default HomeCartLocation;
